module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "protocoloModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "protocoloModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [(_vm.protocoloGerado) ? _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Anote ou imprima o seu número.")]), _vm._v(" "), _c('div', {
    staticClass: "espacado",
    staticStyle: {
      "color": "#004f4a"
    }
  }, [_c('h2', [_vm._v("PROTOCOLO")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.protocoloGerado) + "\n                ")])])]) : _c('div', [_vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.protocoloGerado),
      expression: "protocoloGerado"
    }],
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Imprimir",
      "icone": "fa-print",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Ok",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "protocoloModalLabel"
    }
  }, [_vm._v("\n            Protocolo Gerado\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                O presente "), _c('strong', [_vm._v("protocolo")]), _vm._v(" é um arquivo\n                "), _c('strong', [_vm._v("pessoal")]), _vm._v(". Não é necessário entregar em nenhum\n                setor de Departamento de qualquer Secretaria.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning espacado",
    staticStyle: {
      "text-align": "center",
      "margin": "30px 30px 15px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Este agendamento é\n                anterior à criação de protocolos. Não existe protocolo para\n                este agendamento.\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b2498e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/protocolo-modal.vue
// module id = 4a01
// module chunks = 5